function assert(condition, message) {
    if (!condition) {
        console.error('Assertion failed', message);
        throw new Error(`Assertion error: ${message}`);
    }
}
export { assert };
